import React, { useEffect, useState, useMemo } from "react";
import { DropdownOption, Dropdown } from "@abb/abb-common-ux-react";


import "./kpi-chart.css";
import PeriodList from "../../Period-Dropdown-list/period-dropdown-list";

import kpiData from './kpi-chat-schema.json'
import axios from "axios";
import { BASE_URL } from "../../../strings";
import { getToken } from "../../Authentication/get-token";

const KPIChart = () => {
    const [dropdownValues, setDropdownValues] = useState(
        kpiData.dropdowns.reduce((acc, dropdown) => {
            acc[dropdown.label] = dropdown.placeholder;
            return acc;
        }, {})
    );

    const handleDropdownChange = (label, value) => {
        setDropdownValues({ ...dropdownValues, [label]: value });
    };
  const [kpiResponse, setKpiResponse] = useState(null);
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${BASE_URL}emapi/energy_perf_indicator`,getToken());
        setKpiResponse(response.data);
      } catch (error) {
        console.error("Error fetching KPI data:", error);
        
        // Check for 401 status and trigger session expired popup
        if (error.response?.status === 401) {
          const sessionExpiredEvent = new CustomEvent('sessionExpired', {
            detail: { 
              error: "Authentication failed - Session expired",
              timestamp: new Date().toISOString()
            }
          });
          window.dispatchEvent(sessionExpiredEvent);
        }
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

    const dropdowns = useMemo(() => {
        return kpiData.dropdowns.map((dropdown, index) => (
            <Dropdown
                key={index}
                style={{ visibility: dropdown.visibility }}
                label={dropdown.label}
                placeholder={dropdown.placeholder}
                value={dropdownValues[dropdown.label]}
                onChange={(value) => handleDropdownChange(dropdown.label, value)}
            >
                {dropdown.options.map(option => (
                    <DropdownOption
                        key={option.key}
                        label={option.label}
                        value={option.value}
                    />
                ))}
            </Dropdown>
        ));
    }, [kpiData.dropdowns, dropdownValues]);




    return (
        <>
            <div className="kpi-chart" style={{ width: "100%" }}>
                <div className="indicator-container-top">
                    {dropdowns}
                    <PeriodList />
                </div>

                <div className="kpi-data" style={{ 
                    height: "190px", 
                    display: "flex", 
                    flexDirection: "column", 
                    justifyContent: "center", 
                    alignItems: "center",
                    textAlign: "center"
                }}>
                    {loading ? (
                        <h1>Loading...</h1>
                    ) : (
                        <>
                            <h1>{kpiResponse?.value}</h1>
                            <span>{kpiResponse?.unit}</span>
                        </>
                    )}
                </div>

                <div className="indicator-container">
                    <div className="inside-metrics">
                        <span className="im1">{kpiData.metrics[0].title}</span>
                        <span className="im2">{kpiData.metrics[0].unit}</span>
                        <span className="im3">{kpiData.metrics[0].numerator}</span>
                        <span className="im4">{kpiData.metrics[0].denominator}</span>
                    </div>
                </div>

                <hr className="ind-line" />

                <div className="indicator-container">
                    <div className="inside-metrics">
                        <span className="im1">{kpiData.metrics[1].title}</span>
                        <span className="im2">{kpiData.metrics[1].unit}</span>
                        <span className="im3">{kpiData.metrics[1].numerator}</span>
                        <span className="im4">{kpiData.metrics[1].denominator}</span>
                    </div>
                </div>
            </div>


        </>
    );
};

export default KPIChart;







